import React from 'react'

const ClockIcon = ({color, width, height}: {color?: string; width?: string; height?: string}) => {
  return (
    <svg
      width={width || '20'}
      height={height || '20'}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='Layer_1'>
        <path
          id='Vector'
          d='M10 1.5C8.31886 1.5 6.67547 1.99852 5.27766 2.93251C3.87984 3.8665 2.79037 5.19402 2.14703 6.74719C1.50368 8.30037 1.33535 10.0094 1.66333 11.6583C1.9913 13.3071 2.80085 14.8217 3.9896 16.0104C5.17834 17.1992 6.6929 18.0087 8.34174 18.3367C9.99057 18.6646 11.6996 18.4963 13.2528 17.853C14.806 17.2096 16.1335 16.1202 17.0675 14.7223C18.0015 13.3245 18.5 11.6811 18.5 10C18.5009 8.88351 18.2817 7.77779 17.8549 6.7461C17.428 5.71442 16.8019 4.77702 16.0125 3.98754C15.223 3.19806 14.2856 2.57199 13.2539 2.14515C12.2222 1.71831 11.1165 1.49908 10 1.5ZM10 16.5C8.71442 16.5 7.45772 16.1188 6.3888 15.4046C5.31988 14.6903 4.48676 13.6752 3.99479 12.4874C3.50282 11.2997 3.3741 9.99279 3.6249 8.73192C3.8757 7.47104 4.49477 6.31285 5.40381 5.40381C6.31285 4.49477 7.47104 3.8757 8.73192 3.6249C9.99279 3.37409 11.2997 3.50282 12.4874 3.99479C13.6752 4.48676 14.6903 5.31988 15.4046 6.3888C16.1188 7.45772 16.5 8.71442 16.5 10C16.5017 10.8541 16.3348 11.7001 16.0087 12.4895C15.6827 13.2789 15.2039 13.9961 14.6 14.6C13.9961 15.2039 13.2789 15.6827 12.4895 16.0087C11.7001 16.3348 10.8541 16.5017 10 16.5ZM12.4 8.85L11 9.45V6C11 5.73479 10.8946 5.48043 10.7071 5.2929C10.5196 5.10536 10.2652 5 10 5C9.73479 5 9.48043 5.10536 9.2929 5.2929C9.10536 5.48043 9 5.73479 9 6V11C8.99582 11.1684 9.03501 11.335 9.11382 11.4839C9.19263 11.6327 9.3084 11.7588 9.45 11.85C9.5891 11.9433 9.75086 11.9972 9.91811 12.006C10.0854 12.0148 10.2519 11.9782 10.4 11.9L13.2 10.65C13.7 10.4 13.95 9.85 13.7 9.35C13.45 8.85 12.9 8.6 12.4 8.85Z'
          fill={color ?? 'black'}
        />
      </g>
    </svg>
  )
}

export default ClockIcon
